import React from "react";

import FirstSection from "./Sections/FirstSection";
import SecondSection from "./Sections/SecondSection";
import ThirdSection from "./Sections/ThirdSection";
import FourthSection from "./Sections/FourthSection";
import FivthSection from "./Sections/FivthSection";
import SixthSection from "./Sections/SixthSection";
import SeventhSection from "./Sections/SeventhSection";
import EighthSection from "./Sections/EighthSection";
import NinthSection from "./Sections/NinthSection";
import Footer from "./Footer/Footer";

import { useLanguage } from "../../context/LanguageContext";
import Popup from "../popup/Popup";

const HomePage = () => {
  const { selectedLanguage } = useLanguage(); // Use the context
  return (
    <>
      <Popup />
      <FirstSection language={selectedLanguage} />

      <SecondSection language={selectedLanguage} />

      <ThirdSection language={selectedLanguage} />
      <br />
      <br />
      <br />
      <FourthSection language={selectedLanguage} />

      <br />
      <br />
      <br />
      <FivthSection language={selectedLanguage} />

      <br />
      <br />
      <SixthSection language={selectedLanguage} />

      <br />
      <br />

      <SeventhSection language={selectedLanguage} />
      <br />
      <br />
      <EighthSection language={selectedLanguage} />
      <br />
      <br />

      <NinthSection language={selectedLanguage} />

      <Footer language={selectedLanguage} />
    </>
  );
};

export default HomePage;
